<template>
    <div :class="`assignation ${ratio}`">
        <!-- 页面标题 -->
        <div v-wechat-title="'千年等一回，蜗要爱一回'"></div>

        <!-- 漫画页 -->
        <div :class="`comic ${page === 0 && !isHelp}`" @click="onComic()">
            <div class="wrap">
                <div class="item" v-for="(item,index) in 4" :key="index"></div>
            </div>
        </div>

        <!-- 开屏页 -->
        <div :class="`home ${page === 1}`">
            <div :class="`home-btn ${isHelp}`" @click="homeBtn()"></div>
        </div>

        <!-- 问卷页 -->
        <div :class="`question ${page === 2}`">
            <div class="select">
                <div :class="`item ${selectIndex === index ? 'active': ''}`" v-for="(item,index) in 5" :key="index" @click="selectIndex = index"></div>
            </div>
            <div class="question-btn" @click="questionBtn()"></div>
        </div>

        <!-- 信息页 -->
        <div :class="`info ${page === 3}`" v-if="page === 3">
            <div class="wrap">
                <div class="line">
                    <div class="text" print="姓名："></div>
                    <div class="text" print="蜗仙"></div>
                </div>
                <div class="line">
                    <div class="text" print="ID："></div>
                    <div class="text" print="5201314"></div>
                </div>
                <div class="line">
                    <div class="text" print="身份："></div>
                    <div class="text" print="九阶巨龙"></div>
                </div>
                <div class="line">
                    <div class="text" print="资产："></div>
                    <div class="text" print="10兆白蝌蚪"></div>
                </div>
                <div class="line">
                    <div class="text" print="心动物种："></div>
                    <div class="text" print="蛇族"></div>
                </div>
                <div class="line">
                    <div class="text" print="恋爱宣言："></div>
                    <div class="text" print="蜗不想努力了，蹲个心软的神带蜗回家过年叭~"></div>
                </div>
            </div>
        </div>

        <!-- 匹配页 -->
        <div :class="`match ${page === 4}`" v-if="page === 4">
            <div class="heart">
                <div class="item" v-for="(item,index) in 4" :key="index"></div>
            </div>
            <div class="text">
                <span v-for="(item,index) in match" :key="index" :print="item"></span>
            </div>
            <div class="process">加载中: <span>0</span>%</div>
        </div>

        <!-- 人物页 -->
        <div :class="`role ${page === 5} ${isShowOs ? 'unTouch' : ''}`">
            <div class="num"><span>礼物币: {{ times }}</span></div>
            <div :class="`swiper1 swiper-${swiperRatio}`">
                <div class="swiper-wrapper">
                    <div :class="`swiper-slide slide-${item}`" v-for="(item,index) in 6" :key="index">
                        <div class="btn"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 消息页 -->
        <div :class="`message ${page === 6} ${isShowOs ? 'unTouch' : ''}`">
            <div class="wrap">
                <div :class="`item ${item.red}`" v-for="item in message_list" :key="item.id" @click="onTalk(item.id)"></div>
            </div>
        </div>

        <!-- 用户页 -->
        <div :class="`user ${page === 7} ${isShowOs ? 'unTouch' : ''}`">
            <div class="name">{{ user_info.role_name }}</div>
            <div class="server">{{ user_info.server_name ? `区服:${user_info.server_name}${user_info.server_id}服` : '' }}</div>
            <div class="share-btn" @click="handlePopup({name: 'share', status: true})"></div>
            <div :class="`music-btn ${isAudio}`" @click="audio()"></div>
            <div :class="`user-btn ${['android', 'ios'].includes(user_info.platform) ? 'change': ''}`" @click="userBtn()"></div>
        </div>

        <!-- 页脚 -->
        <div :class="`footer ${[5,6,7].includes(page)} ${isShowOs ? 'unTouch' : ''}`">
            <div :class="`item ${page === index + 5}`" v-for="(item,index) in 3" :key="index" @click="page = index + 5">
                <div class="point" v-show="index === 0 && end_chat < 4"></div>
                <div class="point" v-show="index === 1 && message_num">{{ message_num }}</div>
            </div>
        </div>

        <!-- 弹窗 -->
        <div class="popupWrap">
            <!-- 助力 -->
            <div :class="`popup help ${popup.help} type-${helpType}`">
                <div class="popup-main">
                    <div class="download-btn" @click="goLink('https://snail.qingcigame.com/', '最强蜗牛_春节活动_助力页_点击下载游戏按钮')"></div>
                    <div class="join-btn" @click="goLink('https://h5.qingcigame.com/snail/assignation/enter{timestamp}?enterType=1', '最强蜗牛_春节活动_助力页_点击前往蜗探按钮')"></div>
                </div>
            </div>

            <!-- 聊天 -->
            <div :class="`popup talk ${popup.talk} talk-${roleId} num-${message_num}`" :name="roleName" :num="message_num">
                <div class="popup-main">
                    <!-- 好感度 -->
                    <div :class="`process process-${Math.floor(process/25)}`" @click="handlePopup({name: 'process', status: true})">
                        <div :class="`item ${Math.floor(process/25) >= item}`" v-for="(item,index) in 4" :key="index">
                            <div class="item-mask"></div>
                        </div>
                        <span>{{ process }}%</span>
                    </div>
                    <div :class="`wrap ${process >= 100 && !sendInfo.length && isGet && !popup.mask}`">
                        <div class="item" v-for="(item,index) in talkInfo" :key="index">
                            <!-- 用户消息 -->
                            <div :class="`msg msg-user type-${itemB.user_image_type} ${itemB.user_image ? 'img' : ''}`" v-for="(itemB,indexB) in item.user" :key="`user${indexB}`">
                                <div class="photo"></div>
                                <div :class="`board ${itemB.show_block == 2}`">
                                    <span>{{ itemB.user_msg }}</span>
                                    <img :src="itemB.user_image">
                                </div>
                            </div>
                            <!-- 嘉宾/npc消息 -->
                            <div :class="`msg msg-role type-${itemB.image_type} role-${roleId}`" v-for="(itemB,indexB) in item.role" :key="`role${indexB}`">
                                <div class="photo"></div>
                                <div class="board" v-show="!itemB.reward_id">
                                    <span>{{ itemB.msg }}</span>
                                    <img :src="itemB.image">
                                </div>
                                <div :class="`reward ${itemB.reward_status == 2 ? 'true' : ''}`" v-show="itemB.reward_id" @click="handlePopup({name: 'reward', status: true})"></div>
                            </div>
                            <!-- 系统消息 -->
                            <div :class="`syste ${itemB.type}`" v-for="(itemB,indexB) in item.syste" :key="`syste${indexB}`">
                                <img :src="itemB.image" v-show="itemB.type == 'gift_rich_text_system'">
                                <span>{{ itemB.type === 'rich_text' ? itemB.times : '' }}</span>
                                <span :class="itemB.type === 'text' && itemB.msg.includes('：') ? 'light' : ''">{{ `${itemB.msg.split('：')[0]}${itemB.type === 'text' && itemB.msg.includes('：') ? '：' : ''}` }}</span>
                                <span :class="itemB.type === 'gift_rich_text' ? 'light' : ''">{{ itemB.msg.split('：')[1] }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="close-btn" @click="closeTalk()"></div>
                    <div :class="`send-btn ${process >= 100 && !sendInfo.length && isGet && !popup.mask}`" @click="sendBtn()"></div>
                    <div class="return-btn" v-show="(process >= 100 && !sendInfo.length && isGet && !popup.mask) || roleId <= 5" @click="returnBtn()"></div>
                    <div :class="`notice-icon icon-${roleId} gift-${giftId}`"></div>
                    <div :class="`change-icon icon-${roleId}`"></div>
                </div>
            </div>

            <!-- 对话 -->
            <div :class="`popup send ${popup.send}`" @click.self="handlePopup({name: 'send', status: false})">
                <div class="popup-main">
                    <div class="close-btn" @click="handlePopup({name: 'send', status: false})"></div>
                    <div class="meet" v-show="!talkInfo.filter(item => item.user.length).length">
                        <span>初次打招呼帮您准备了见面语~</span>
                        <span>选一个邀请她聊天吧~</span>
                    </div>
                    <div :class="`item ${Boolean(item.user_image)}`" v-for="item in sendInfo" :key="item.user_message_id" @click="onSend({msg: item.user_message, msg_id: item.user_message_id})">
                        <img :src="item.user_image">
                        <span>{{item.user_message}}</span>
                    </div>
                    <div class="item false" v-show="process < 100 && !sendInfo.length" @click="handlePopup({name: 'gift', status: true})"><span>挑个礼物送给她吧~</span></div>
                </div>
            </div>

            <!-- 引导 -->
            <div :class="`popup guide ${popup.guide}`" @click.self="guide()">
                <div class="popup-main"></div>
            </div>

            <!-- 好感 -->
            <div :class="`popup process ${popup.process} role-${roleId}`" @click.self="handlePopup({name: 'process', status: false})">
                <div class="popup-main">
                    <div :class="`icon ${process/25 >= index + 1 ? 'true' : ''}`" v-for="(item,index) in 4" :key="index"></div>
                    <span>{{ process }}%</span>
                </div>
            </div>

            <!-- 红包 -->
            <div :class="`popup reward ${popup.reward}`" @click.self="handlePopup({name: 'reward', status: false})">
                <div :class="`popup-main role-${roleId} ${isGet}`" @click="onReward(roleId)">
                    <div class="card prev"></div>
                    <div class="card next"></div>
                </div>
            </div>

            <!-- 送礼 -->
            <div :class="`popup gift ${popup.gift}`" @click.self="handlePopup({name: 'gift', status: false})">
                <div class="popup-main">
                    <div class="close-btn" @click="handlePopup({name: 'gift', status: false})"></div>
                    <div class="num">当前礼物币:{{ times }}</div>
                    <div class="share-btn" @click="handlePopup({name: 'share', status: true})">获取礼物币>></div>
                    <span v-for="(item,index) in 3" :key="index" @click="onGift(3 - index)"></span>
                </div>
            </div>

            <!-- 分享 -->
            <div :class="`popup share ${popup.share}`" @click.self="handlePopup({name: 'share', status: false})">
                <div class="popup-main">
                    <div class="clipboard-btn" @click="copyLink('.clipboard-btn')" data-event="复制活动链接" :data-clipboard-text="share_text"></div>
                </div>
            </div>

            <!-- 结束 -->
            <div :class="`popup end ${popup.end}`">
                <div class="popup-main">
                    <div class="wrap">
                        <div class="item" v-for="(item,index) in 11" :key="index"></div>
                    </div>
                    <div class="close-btn" @click="endClose()"></div>
                </div>
            </div>

            <!-- 防抖遮罩 -->
            <div :class="`popup mask ${popup.mask}`"></div>
        </div>

        <!-- 登录弹窗 -->
        <Login v-if='isShowLogin' v-on:channelCallback='channelBack()' :gameName="gameName" :loginTypes='loginTypes' :downloadUrl='downloadUrl' channelTips='角色UID可在游戏中—设置—UID查看' noAuthLogin></Login>

        <!-- 绑定弹窗 -->
        <Os v-if='isShowOs' v-on:selectCallback='osBack()' v-on:logoutCallback='osCancel' :gameName='gameName'></Os>
    </div>
</template>

<script>
import Vue from "vue"
import { Toast } from "mint-ui"
import { mapState, mapMutations, mapActions } from "vuex"
import { getTimeStamp, buriedLogger, analysisParams } from "@/utils/utils"
import Login from "@/components/login"
import Os from "@/components/os"
import { onInitAPI, onLogoutAPI, onPushAPI, onGuestAPI, onEnterAPI, onGiftAPI, onBlackAPI, onInviteAPI, onRewardAPI, onClickAPI, onGuideAPI } from "../api"
import { swiper } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Clipboard from 'clipboard'
import '../howler'

export default {
    name: 'assignation',
    data() {
        return {
            gameName: 'snail',
            loginTypes: ['sms', 'password', 'channel'],
            downloadUrl: 'https://snail.qingcigame.com/',
            ratio: null, // 屏幕比例
            page: null, // 0,漫画页，1开屏页，2问卷页，3信息页，4匹配页，5人物页，6消息页，7用户页
            selectIndex: null, // 问卷索引
            match: ['亲爱的用户~正在为您加速解析中~', '前方排队', '1314520', '位会员, 请您耐心等候...', '系统已解析~火速进入匹配页面！！'], // 匹配页文案
            isAudio: true, // 播放音频
            share_text: '', // 分享文案
            helpType: 0, // 助力弹窗，0助力成功，1不能为自己助力，2今日已助力
            giftId: 1, // 送礼id
            isOld: 0, // 是否为老用户，0为新用户，1为老用户
            finishEnd: 0, // 是否完成结束页，0未完成，1已完成
            swiperRatio: 'ratio1',
            popup: {
                help: false, // 助力页
                talk: false, // 聊天页
                guide: false, // 引导
                share: false, // 分享
                process: false, // 好感
                send: false, // 发送选项
                reward: false, // 红包
                gift: false, // 送礼
                end: false, // 结束
                popup: false, // 开启弹窗
            },
            user_info: {}, // 用户信息
            gift_list: [], // 礼物信息
            invitation_code: null, // 邀请码
            message_list: [], // 列表消息
            reward_list: [{}, {}, {}, {}, {}, {}, {}], // 奖励列表
            times: 0, // 礼物币
            message_num: 0, // 未读消息
            talkInfo: [], // 聊天消息
            sendInfo: [], // 回复消息
            isHelp: false, // 通过分享进入
            roleId: '', // 聊天对象
            roleName: '', // 聊天对象
            process: 0, // 好感进度
            isGet: false, // 当前红包是否领取
            end_chat: 0, // 全流程结束，>=4时结束
            end_chat_record: 0, // 临时记录end_chat
            change_likability: 0, // 好感度变化
        }
    },
    components: { Login, Os, swiper },
    computed: {
        message_num_top() {
            // 聊天页顶部未读消息数
            if (this.message_list[this.roleId - 1] && this.message_list[this.roleId - 1].red) {
                return this.message_num - 1
            } else {
                return this.message_num
            }
        },
        ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs'])
    },
    created() {
        if (!global.consoleSwitch) console.log = () => {}
        window.addEventListener('pageshow', this.resize)
        window.addEventListener('resize', this.resize)
        this.setInitActiveInfo()
        this.setInitUserInfo()
        const bl = buriedLogger('snail', '最强蜗牛_春节活动')
        this.logger = bl
        setTimeout(() => { this.logger.sum('最强蜗牛_春节活动_访问页面') }, 200)
        this.isSetShare()
    },
    mounted() {
        this.onInit(true)
        this.swiperInit()
        this.audio(true)
    },
    methods: {
        // 自适应
        resize() {
            setTimeout(() => {
                if (window.innerWidth < 540) {
                    if (this.isFocus) return
                    const ratio = window.innerWidth / window.innerHeight
                    if (ratio > 320 / 510) {
                        this.ratio = 'ratio1'
                    } else if (ratio > 320 / 570) {
                        this.ratio = 'ratio2'
                    } else {
                        this.ratio = ''
                    }
                    if (ratio > 320 / 544) {
                        this.swiperRatio = 'ratio1'
                    } else if (ratio > 320 / 620) {
                        this.swiperRatio = 'ratio2'
                    } else {
                        this.swiperRatio = ''
                    }
                } else {
                    document.documentElement.style.fontSize = '54px'
                }
                if (this.swiper1) {
                    this.swiper1.update()
                    this.swiper1.slideTo(this.swiper1.activeIndex)
                }
            }, 320)
        },
        // 控制弹窗
        handlePopup({name, status}) {
            const that = this
            if (name === 'login') {
                this.changeLoginPopup(true)
                this.logger.sum('最强蜗牛_春节活动_打开登录弹窗')
            } else if (name === 'os') {
                this.changeOsPopup(true)
            } else {
                this.popup[name] = status
                this.popup.popup = status
                if (status) {
                    switch (name) {
                        case 'help':
                            this.logger.sum('最强蜗牛_春节活动_访问助力页')
                            break
                        case 'share':
                            if (this.popup.gift) this.logger.sum('最强蜗牛_春节活动_聊天页点击获取礼物币按钮打开分享弹窗')
                            if (this.page == 7) this.logger.sum('最强蜗牛_春节活动_用户页点击去完成按钮打开分享弹窗')
                            this.logger.sum('最强蜗牛_春节活动_打开分享弹窗')
                            break
                        case 'process':
                            this.logger.sum('最强蜗牛_春节活动_点击密码宝箱按钮')
                            break
                        case 'reward':
                            const obj = { 4: 5, 5: 6, 6: 1, 7: 2, 8: 3, 9: 4 }
                            this.isGet = this.reward_list[obj[this.roleId] - 1].status === 2
                            this.logger.sum('最强蜗牛_春节活动_打开红包弹窗')
                            break
                        case 'guide':
                            document.querySelector('.popup.guide').addEventListener('mouseup', () => {
                                if (document.querySelector('.popup.guide').classList.value.includes('show')) {
                                    localStorage.setItem(`snail_assignation_guide_${this.user_info.role_id}`, true)
                                    this.handlePopup({name: 'guide', status: false})
                                }
                            })
                            document.querySelector('.popup.guide').addEventListener('touchend', () => {
                                if (document.querySelector('.popup.guide').classList.value.includes('show')) {
                                    localStorage.setItem(`snail_assignation_guide_${this.user_info.role_id}`, true)
                                    this.handlePopup({name: 'guide', status: false})
                                }
                            })
                            break
                        case 'talk':
                            setTimeout(() => {
                                document.querySelectorAll('.popup.talk .process .item.false .item-mask').forEach(item => {
                                    item.classList.add('ani')
                                })
                            }, 300)
                            break
                    }
                } else {
                    if (name == 'talk') {
                        setTimeout(() => {
                            that.talkInfo = []
                            document.querySelectorAll('.popup.talk .process .item .item-mask.ani').forEach(item => {
                                item.classList.remove('ani')
                            })
                        }, 300)
                    }
                }
            }
        },
        // 登录校验
        checkLogin(code) {
            if (!this.user_info.role_id || code == 401) {
                this.user_info = {}
                this.page = 1
                this.handlePopup({name: 'talk', status: false})
                this.handlePopup({name: 'send', status: false})
                this.handlePopup({name: 'reward', status: false})
                this.handlePopup({name: 'gift', status: false})
                this.selectIndex = null
                this.end_chat = 0
                this.end_chat_record = 0
                this.handlePopup({name: 'login', status: true})
                this.onToast('请先登录')
                return false
            }
            return true
        },
        // 漫画页判定
        comic() {
            const { invitation_code, enterType } = analysisParams(location.href)
            if (invitation_code) {
                this.isHelp = true
                this.page = 1
                this.osCancel()
            } else if (enterType == 1 && this.user_info.role_id) {
                this.homeBtn()
            } else if (!localStorage.getItem('.snail_assignation_comic')) {
                this.page = 0
                document.querySelector('.comic').classList.add('ani')
                setTimeout(() => { document.querySelector('.comic').classList.add('over') }, 3800)
            } else {
                this.page = 1
            }
        },
        // 点击漫画页
        onComic () {
            if (document.querySelector('.comic').classList.value.includes('over')) {
                this.page = 1
                localStorage.setItem('.snail_assignation_comic', true)
            } else {
                document.querySelector('.comic').classList.add('over')
            }
        },
        /*
        * 功能：是否为新用户
        * @param end {number} end为空-已完成新手引导，end为1-已完成结束页动画
        */
        onGuide(end) {
            onGuideAPI({
                end
            }).then((response) => {
                if (Number(response.code) === 200) {
                    
                    return
                }
                this.onToast(response.message)
                this.checkLogin(Number(response.code))
            })
        },
        // 初始化
        onInit(isFirst) {
            onInitAPI().then((response) => {
                if (Number(response.code) === 200) {
                    this.onInitDataCallback(response)
                    this.setUserInfo(response.data.user_info)
                    this.user_info = response.data.user_info
                    this.gift_list = response.data.activity.gift_list
                    this.isOld = response.data.activity.guide
                    this.invitation_code = response.data.activity.invitation_code
                    this.message_list = response.data.activity.message_list
                    this.reward_list = response.data.activity.reward_list
                    this.times = response.data.activity.times
                    this.message_num = this.message_list.filter(item => item.red).length
                    this.end_chat = response.data.activity.end_chat
                    this.finishEnd = response.data.activity.end
                    if (isFirst) this.end_chat_record = this.end_chat
                    return
                }
                if (Number(response.code) === 402) {
                    this.handlePopup({name: 'mask', status: true})
                }
                Number(response.code) !== 401 && this.onToast(response.message)
            }).finally(() => {
                if (isFirst) this.comic()
            })
        },
        // 开屏页按钮-进入蜗探
        homeBtn() {
            if (this.isShowLogin || this.isShowOs) return
            if (this.checkLogin()) {
                if (!this.isHelp) {
                    // 活动链接访问
                    this.logger.sum('最强蜗牛_春节活动_开屏页点击进入蜗探按钮')
                    if (!this.isOld) {
                        // 首次进入
                        this.page = 2
                    } else {
                        this.page = 5
                        if (!localStorage.getItem(`snail_assignation_guide_${this.user_info.role_id}`)) this.handlePopup({name: 'guide', status: true}) // 首次进入打开引导弹窗
                    }
                }
            }
        },
        // 问卷页按钮-进入蜗探
        questionBtn() {
            this.logger.sum('最强蜗牛_春节活动_问卷页点击进入蜗探按钮')
            if (this.selectIndex || this.selectIndex === 0) {
                this.infoAni()
                this.logger.sum(`最强蜗牛_春节活动_问卷页选择选项${this.selectIndex + 1}`)
            } else {
                this.onToast('请选择交友目的')
            }
        },
        // 信息页动画
        infoAni() {
            this.page = 3
            this.$nextTick(() => {
                const textArr = document.querySelectorAll('.info .wrap .text')
                let delay = 0
                textArr.forEach((item, index) => {
                    this.print({element: item, delay})
                    delay += item.getAttribute("print").length * 80
                    if (index === textArr.length - 1) {
                        setTimeout(() => { document.querySelector('.info').classList.add('over') }, delay)
                        setTimeout(() => { this.matchAni() }, delay + 800) // 匹配页动画
                    }
                })
            })
        },
        // 匹配页动画
        matchAni() {
            this.page = 4
            const that = this
            this.$nextTick(() => {
                let delay2 = 0
                const spanArr = document.querySelectorAll('.match .text span')
                spanArr.forEach((item,index) => {
                    if (index === spanArr.length - 1) {
                        delay2 += 400
                        setTimeout(() => { document.querySelector('.match .text').classList.add('over') }, delay2) // 匹配成功
                        setTimeout(() => {
                            that.page = 5 // 进入选择页
                            if (!localStorage.getItem(`snail_assignation_guide_${that.user_info.role_id}`)) this.handlePopup({name: 'guide', status: true}) // 首次进入打开引导弹窗
                        }, delay2 + 1500)
                        if (!this.isOld) this.onGuide()
                    }
                    that.print({element: item, delay: delay2})
                    delay2 += item.getAttribute("print").length * 80
                })
                const timer = setInterval(() => { 
                    document.querySelector('.match .process span').innerHTML = Number(document.querySelector('.match .process span').innerHTML) + 1
                    if (document.querySelector('.match .process span').innerHTML >= 100) clearInterval(timer)
                }, 30)
            })
        },
        // 轮播初始化
        swiperInit() {
            const that = this
            this.$nextTick(() => {
                this.swiper1 = new Swiper('.swiper1', {
                    effect : 'coverflow',
                    centeredSlides: true,
                    coverflow: {
                        rotate: 0,
                        stretch: document.querySelector('.swiper1 .swiper-slide').offsetWidth,
                        depth: 0,
                        slideShadows : false
                    },
                    loop: true,
                    loopAdditionalSlides: 20,
                    onTap: function(swiper, event) {
                        if (event.target.className.includes('btn')) {
                            that.onTalk(swiper.realIndex + 4)
                            that.logger.sum('最强蜗牛_春节活动_首页点击发起聊天按钮')
                        }
                    }
                })
            })
        },
        // 点击引导弹窗
        guide() {
            document.querySelector('.popup.guide').classList.add('show')
        },
        // 注销 || 切换角色按钮
        userBtn() {
            if(['android', 'ios'].includes(this.user_info.platform)) {
                this.handlePopup({name: 'os', status: true})
            } else {
                this.osCancel()
            }
        },
        channelBack() {
            this.onInit()
            if (this.isHelp) {
                // 助力页
                this.logger.sum('最强蜗牛_春节活动_助力页_点击加入蜗探按钮')
                const { invitation_code } = analysisParams(location.href)
                this.handlePopup({name: 'mask', status: true})
                onInviteAPI({invitation_code}).then((response) => {
                    this.handlePopup({name: 'mask', status: false})
                    switch (Number(response.code)) {
                        case 200:
                            // 助力成功
                            this.helpType = 0
                            this.handlePopup({name: 'help', status: true})
                            break
                        case 405:
                            // 不能为自己助力
                            this.helpType = 1
                            this.handlePopup({name: 'help', status: true})
                            break
                        case 406:
                            // 今日已助力
                            this.helpType = 2
                            this.handlePopup({name: 'help', status: true})
                            break
                        default:
                            this.onToast(response.message)
                    }
                })
            }
        },
        // 切换角色的回调
        osBack() {
            this.onInit()
            if (this.isHelp) {
                // 助力页
                this.logger.sum('最强蜗牛_春节活动_助力页_点击加入蜗探按钮')
                const { invitation_code } = analysisParams(location.href)
                this.handlePopup({name: 'mask', status: true})
                onInviteAPI({invitation_code}).then((response) => {
                    this.handlePopup({name: 'mask', status: false})
                    switch (Number(response.code)) {
                        case 200:
                            // 助力成功
                            this.helpType = 0
                            this.handlePopup({name: 'help', status: true})
                            break
                        case 405:
                            // 不能为自己助力
                            this.helpType = 1
                            this.handlePopup({name: 'help', status: true})
                            break
                        case 406:
                            // 今日已助力
                            this.helpType = 2
                            this.handlePopup({name: 'help', status: true})
                            break
                        default:
                            this.onToast(response.message)
                    }
                })
            } else {
                // 活动页
                this.selectIndex = null
                setTimeout(() => { this.page = this.isOld ? 5 : 2 }, 200)
            }
        },
        // 控制音频
        audio(first) {
            if (first) {
                // 首次调用
                this.music = new Howl({
                    src: ['https://download4.qcplay.com/file/snail_bgm.mp3'],
                    autoplay: true,
                    loop: true
                })
                this.music.play()
            } else {
                this.isAudio = !this.isAudio
                if (this.isAudio) {
                    this.music.play()
                } else {
                    this.music.pause()
                }
                if (this.reward_list[6].status !== 2) {
                    onClickAPI({reward_id: 7}).then((response) => {
                        if (Number(response.code) === 200) {
                            if (response.data.is_send) {
                                this.onToast('被你找到彩蛋啦，礼物已送达至邮箱~')
                                this.logger.sum('最强蜗牛_春节活动_领取音乐彩蛋奖励')
                                this.onInit()
                            } else {
                                this.onToast(this.isAudio ? '背景音乐已开启~' : '背景音乐已关闭~')
                            }
                            return
                        }
                        this.onToast(response.message)
                        this.checkLogin(Number(response.code))
                    })
                } else {
                    this.onToast(this.isAudio ? '背景音乐已开启~' : '背景音乐已关闭~')
                }
                this.logger.sum('最强蜗牛_春节活动_点击音乐按钮')
            }
        },
        // 进入聊天
        onTalk(id, isSend) {
            this.handlePopup({name: 'mask', status: true})
            if ([1,2,3,4,5].includes(id)) {
                // npc
                onPushAPI({npc_id: id}).then((response) => {
                    this.handlePopup({name: 'mask', status: false})
                    if (Number(response.code) === 200) {
                        this.talkInfo = response.data.notice[0].message.reverse()
                        this.process = response.data.notice[0].likability
                        this.roleId = id
                        const obj = { 4: 5, 5: 6, 6: 1, 7: 2, 8: 3, 9: 4 }
                        // id-key：1小探，2于吉，3貂蝉，4顶罐子蜗牛，5春姬，6白素针，7黑色素，8蜗海，9小青灵
                        // id-value：1.甜蜜礼包（白素针）2.如意礼包（黑色素）3.心动礼包（蜗海）4.诚爱礼包（小青灵）5.暖冬小礼（顶罐子蜗牛彩蛋）6.暖冬小礼（春姬彩蛋）7.新春礼包（关闭音频彩蛋）
                        if (this.reward_list[obj[this.roleId] - 1]) this.isGet = this.reward_list[obj[this.roleId] - 1].status === 2
                        this.roleName = ['小探', '于吉', '貂蝉', '顶罐子蜗牛', '春姬', '白素针', '黑色素', '蜗海', '小青灵'][id - 1]
                        this.handlePopup({name: 'talk', status: true})
                        setTimeout(() => {
                            let height = 0
                            document.querySelectorAll('.popup.talk .wrap .item').forEach(item => height += item.offsetHeight)
                            document.querySelector('.popup.talk .wrap').scrollTop += height
                        }, 100)
                        return
                    }
                    this.checkLogin(Number(response.code))
                    this.onToast(response.message)
                })
            } else {
                // 嘉宾
                onEnterAPI({guest_id: id}).then((response) => {
                    if (Number(response.code) === 200){
                        if (isSend) {
                            this.handlePopup({name: 'mask', status: false})
                            this.handleTalk(response.data.notice[0].message.reverse())
                            this.sendInfo = response.data.user_message_list[0].content
                            this.process = response.data.notice[0].likability
                            this.roleId = id
                            this.end_chat = response.data.user_message_list[0].end_chat
                            const obj = { 4: 5, 5: 6, 6: 1, 7: 2, 8: 3, 9: 4 }
                            this.isGet = this.reward_list[obj[this.roleId] - 1].status === 2
                            this.roleName = ['小探', '于吉', '貂蝉', '顶罐子蜗牛', '春姬', '白素针', '黑色素', '蜗海', '小青灵'][id - 1]
                            this.handlePopup({name: 'talk', status: true})
                        } else {
                            this.handlePopup({name: 'mask', status: false})
                            this.talkInfo = response.data.notice[0].message.reverse()
                            this.sendInfo = response.data.user_message_list[0].content
                            this.process = response.data.notice[0].likability
                            this.roleId = id
                            this.end_chat = response.data.user_message_list[0].end_chat
                            const obj = { 4: 5, 5: 6, 6: 1, 7: 2, 8: 3, 9: 4 }
                            this.isGet = this.reward_list[obj[this.roleId] - 1].status === 2
                            this.roleName = ['小探', '于吉', '貂蝉', '顶罐子蜗牛', '春姬', '白素针', '黑色素', '蜗海', '小青灵'][id - 1]
                            this.handlePopup({name: 'talk', status: true})
                            setTimeout(() => {
                                let height = 0
                                document.querySelectorAll('.popup.talk .wrap .item').forEach(item => height += item.offsetHeight)
                                document.querySelector('.popup.talk .wrap').scrollTop += height
                            }, 100)
                        }
                        return
                    }
                    this.checkLogin(Number(response.code))
                    this.onToast(response.message)
                })
            }
        },
        // 关闭聊天
        closeTalk() {
            const that = this
            setTimeout(() => {
                if (that.end_chat >= 4 && !that.finishEnd) {
                    that.handlePopup({name: 'end', status: true})
                    that.onGuide(1)
                    setTimeout(() => { that.onInit() }, 300)
                } else {
                    that.onInit()
                    let roleArr = []
                    that.talkInfo.forEach(item => {roleArr = roleArr.concat(item.role)})
                    roleArr.filter(item => item.reward_id && item.reward_status === 1).length ? that.onToast('请领取礼包再返回哦~') : that.handlePopup({name: 'talk', status: false})
                }
            }, 200)
            this.logger.sum('最强蜗牛_春节活动_聊天页点击左上角返回按钮')
        },
        // 补充间隔
        handleTalk(targetArr) {
            const autoScroll = () => {
                setTimeout(() => {
                    let height = 0
                    document.querySelectorAll('.popup.talk .wrap .item').forEach(item => height += item.offsetHeight)
                    document.querySelector('.popup.talk .wrap').scrollTo({left: 0, top: document.querySelector('.popup.talk .wrap').scrollTop + height, behavior: 'smooth', duration: 200})
                }, 100)
            }
            return new Promise((resolve, reject) => {
                this.popup.mask = true
                const that = this
                const timer = setInterval(() => {
                    if (that.talkInfo[that.talkInfo.length - 1]) {
                        const infoArr = that.talkInfo
                        if (that.talkInfo[that.talkInfo.length - 1].user.length !== targetArr[that.talkInfo.length - 1].user.length) {
                            infoArr[infoArr.length - 1].user.push(targetArr[infoArr.length - 1].user[infoArr[infoArr.length - 1].user.length])
                            that.talkInfo = infoArr
                            autoScroll()
                        } else if (that.talkInfo[that.talkInfo.length - 1].role.length !== targetArr[that.talkInfo.length - 1].role.length) {
                            infoArr[infoArr.length - 1].role.push(targetArr[infoArr.length - 1].role[infoArr[infoArr.length - 1].role.length])
                            that.talkInfo = infoArr    
                            autoScroll()                        
                        } else if (that.talkInfo[that.talkInfo.length - 1].syste.length !== targetArr[that.talkInfo.length - 1].syste.length) {
                            infoArr[infoArr.length - 1] = targetArr[infoArr.length - 1]
                            that.talkInfo = infoArr
                            autoScroll()
                        } else if (that.talkInfo.length !== targetArr.length) {
                            if (targetArr[that.talkInfo.length].user.length) {
                                infoArr.push({user: [targetArr[that.talkInfo.length].user[0]], role: [], syste: []})
                                that.talkInfo = infoArr
                                autoScroll()
                            } else if (targetArr[that.talkInfo.length].role.length) {
                                infoArr.push({user: [], role: [targetArr[that.talkInfo.length].role[0]], syste: []})
                                that.talkInfo = infoArr
                                autoScroll()
                            } else if (targetArr[that.talkInfo.length].syste.length) {
                                infoArr.push({user: [], role: [], syste: targetArr[that.talkInfo.length].syste})
                                that.talkInfo = infoArr
                                autoScroll()
                            } else {
                                infoArr.push({user: [], role: [], syste: []})
                                that.talkInfo = infoArr
                            }
                        } else {
                            infoArr.push({user: [], role: [], syste: []})
                            that.talkInfo = infoArr
                            autoScroll()
                            clearInterval(timer)
                            that.popup.mask = false
                            resolve()
                        }
                    } else {
                        if (targetArr[0].user.length) {
                            that.talkInfo = [{user: [targetArr[0].user[0]], role: [], syste: []}]
                            autoScroll()
                        } else if (targetArr[0].role.length) {
                            that.talkInfo = [{user: [], role: [targetArr[0].role[0]], syste: []}]
                            autoScroll()
                        } else if (targetArr[0].syste.length) {
                            that.talkInfo = [{user: [], role: [], syste: targetArr[0].syste}]
                            autoScroll()
                        } else {
                            that.talkInfo = [{user: [], role: [], syste: []}]
                        }
                    }
                }, 800)
            })
        },
        // 关闭结束页按钮
        endClose() {
            this.logger.sum('最强蜗牛_春节活动_点击蜗知道啦！回家过年去咯按钮')
            this.page = 5
            this.handlePopup({name: 'talk', status: false})
            this.handlePopup({name: 'end', status: false})
        },
        // 聊天页-聊天框按钮-打开对话弹窗
        sendBtn() {
            if (this.process < 100 || this.sendInfo.length) {
                // 显示为聊天框
                if (this.roleId >= 6) {
                    // 和嘉宾对话
                    let roleArr = []
                    this.talkInfo.forEach(item => {roleArr = roleArr.concat(item.role)})
                    this.handlePopup({name: 'send', status: true})
                }
            } else {
                if (this.roleId >= 6) {
                    // 和嘉宾对话
                    let roleArr = []
                    this.talkInfo.forEach(item => {roleArr = roleArr.concat(item.role)})
                    if (roleArr.filter(item => item.reward_id && item.reward_status === 1).length) this.onToast('请收下礼包再聊天哦~')
                }
            }
        },
        returnBtn() {
            this.page = 5
            this.closeTalk()
        },
        // 领取红包
        onReward(npc_id) {
            if (this.isGet) return
            const that = this
            const ani = () => {
                document.querySelectorAll('.popup.reward .card').forEach(item => {
                    item.classList.toggle('ani')
                })
            }
            this.handlePopup({name: 'mask', status: true})
            onRewardAPI({npc_id}).then((response) => {
                this.handlePopup({name: 'mask', status: false})
                if (Number(response.code) === 200) {
                    const name = ['小探','于吉','貂蝉','顶罐子蜗牛','春姬','白素针','黑色素','蜗海','小青灵'][npc_id - 1]
                    this.logger.sum(`最强蜗牛_春节活动_领取${name}红包`)
                    ani()
                    that.onInit()
                    setTimeout(() => { that.onTalk(that.roleId) }, 400)
                    setTimeout(() => { ani() }, 800)
                    return
                }
                this.checkLogin(Number(response.code))
                this.onToast(response.message)
            })
        },
        // 发送消息
        onSend({msg, msg_id}) {
            const that = this
            this.handlePopup({name: 'mask', status: true})
            if (msg.includes('拉黑')) {
                // 拉黑
                onBlackAPI({npc_id: this.roleId}).then((response) => {
                    this.handlePopup({name: 'mask', status: false})
                    if (Number(response.code) === 200) {
                        this.end_chat_record = this.end_chat
                        this.onInit()
                        setTimeout(() => {
                            that.onTalk(that.roleId, true)
                            that.handlePopup({name: 'send', status: false})
                        }, 300)
                        return
                    }
                    this.onToast(response.message)
                    this.checkLogin(Number(response.code))
                })
            } else {
                // 对话
                onGuestAPI({guest_id: this.roleId, msg_id}).then((response) => {
                    this.handlePopup({name: 'mask', status: false})
                    if (Number(response.code) === 200) {
                        this.end_chat_record = this.end_chat
                        this.onInit()
                        setTimeout(() => {
                            that.onTalk(this.roleId, true)
                            that.handlePopup({name: 'send', status: false})
                            that.change_likability = response.data.change_likability
                            if (that.change_likability) {
                                const span = document.createElement('span')
                                span.setAttribute('num', that.change_likability)
                                document.querySelector('.popup.talk .change-icon').appendChild(span)
                            }
                        }, 300)
                        return
                    }
                    this.checkLogin(Number(response.code))
                    this.onToast(response.message)
                })
            }
        },
        // 赠送礼物
        onGift(gift_id) {
            if (this.times < 4 - gift_id) {
                this.handlePopup({name: 'share', status: true})
                this.onToast('礼物币不足')
                return
            }
            this.giftId = gift_id
            this.handlePopup({name: 'mask', status: true})
            onGiftAPI({guest_id: this.roleId, gift_id}).then((response) => {
                this.handlePopup({name: 'mask', status: false})
                if (Number(response.code) === 200) {
                    const name = ['只因有你', '砰然心动', '梦幻豆角'][gift_id - 1]
                    this.logger.sum(`最强蜗牛_春节活动_赠送礼物${name}`)
                    document.querySelector('.popup.talk .notice-icon').appendChild(document.createElement('span'))
                    this.onInit()
                    this.onTalk(this.roleId, true)
                    this.handlePopup({name: 'send', status: false})
                    this.handlePopup({name: 'gift', status: false})
                    return
                }
                this.checkLogin(Number(response.code))
                this.onToast(response.message)
            })
        },
        /*
        * 功能：打印文本
        * @param element 必须，需要打印的元素
        * @param delay 非必须，延迟多久执行，默认为0，单位ms {number}
        * @param time 非必须，打印间隔，默认为80ms {number}
        */
        print({element, delay, time}) {
            const text = element.getAttribute("print")
            if (time === 0) element.setAttribute('at_once', true)
            delay = delay || 0
            time = time || 80
            setTimeout(() => {
                if (text && !element.innerHTML) {
                const textArr = text.split("")
                const timer = setInterval(() => {
                    const str = textArr.shift()
                    str === "/" ? (element.innerHTML += `<br/>`) : (element.innerHTML += str)
                    if (!textArr.length || element.getAttribute('at_once')) clearInterval(timer)
                    if (element.getAttribute('at_once')) {
                        element.innerHTML = text.replaceAll('/', '<br/>')
                        setTimeout(() => { element.removeAttribute('at_once') }, 500)
                    }
                }, time)
                }
            }, delay)
        },
        // 注销
        osCancel() {
            onLogoutAPI({
                game_id: this.user_info.game_id
            }).then((response) => {
                if (Number(response.code) === 200) {
                    this.setInitUserInfo()
                    this.user_info = {}
                    this.page = 1
                    this.selectIndex = null
                    this.end_chat = 0
                    this.end_chat_record = 0
                    return
                }
                this.onToast(response.message)
            })
        },
        // 复制链接
        copyLink(copyName) {
            this.share_text = `【最强蜗牛】叮~刚刚附近有蜗喜欢了你，打开蜗探看看是谁吧，速戳开启心动邂逅 https://h5.qingcigame.com/snail/assignation/enter${getTimeStamp()}?invitation_code=${this.invitation_code}`
            var _this = this
            const clipboard = new Clipboard(copyName)
            clipboard.on('success', (e) => {
                _this.onToast('复制成功')
                e.clearSelection()
                this.logger.sum('最强蜗牛_春节活动_复制成功')
            })
            clipboard.on('error', (e) => { _this.onToast('复制失败') })
        },
        // 微信分享
        isSetShare() {
            this.setShare({
                link: `https://h5.qingcigame.com/snail/assignation/enter${getTimeStamp()}`,
                title: '春节相亲防骗指南',
                imgUrl: 'https://download4.qcplay.com/qcgame-api/c5RYqgXFjooSOnluqvwfkmSbhA51KnNBdXMad9RE.png',
                desc: '被催婚？用蜗探就够了，攻略嘉宾更有道具豪礼相送',
            })
        },
        // TAG: 其他简易封装的方法
        onToast(config) {
            const curConfig = { duration: 1000, className: 'toasts' }
            if (!config) {
                console.error('缺少config参数')
                return false
            }
            if (typeof config === 'string') curConfig.message = config
            Toast(curConfig)
        },
        // 前往重定向
        goLink(url, loggerName) {
            if (url === '') return
            this.logger.sum(loggerName)
            setTimeout(() => { location.href = url }, 200)
        },
        ...mapMutations(['setUserInfo', 'changeLoginPopup', 'changeOsPopup', 'setInitActiveInfo', 'setInitUserInfo']),
        ...mapActions(['onInitDataCallback', 'setShare'])
    }
}
</script>

<style lang="less">
@import './index.less';
</style>


// WEBPACK FOOTER //
// src/pages/snail/assignation/index/index.vue